import {pageInfo, initPage,exportData, addInitPage, submit,saveTruckData, saveDriverData,uploadUrl,orderBasicDetailsInfo} from './../api';
import { getCarrierCode, findTrucksByCarrierNo, findDriversByCarrierNo } from '../../../../api'
const appointment = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    exportObj: null,
    addInitUpdateObj: null,
    initCarrierObj: null,
    initTruckObj: null,
    initDriverObj: null,
    submitObj: null,
    saveTruckObj: null,
    saveDriverObj: null,
    uploadUrlObj: null,
    orderBasicInfoObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    ADD_INIT_UPDATE(state,data) {
      state.addInitUpdateObj = data || {};
    },
    INIT_CARRIER(state, data) {
      state.initCarrierObj = data.obj;
    },
    INIT_TRUCK(state, data) {
      state.initTruckObj = data.obj;
    },
    INIT_DRIVER(state, data) {
      state.initDriverObj = data.obj;
    },
    SUBMIT_DATA(state, data) {
      state.submitObj = data || {};
    },
    SAVE_TRUCK_DATA(state, data) {
      state.saveTruckObj = data || {};
    },
    SAVE_DRIVER_DATA(state, data) {
      state.saveDriverObj = data || {};
    },
    UPLOAD_URL_DATA(state, data){
      state.uploadUrlObj = data || '';
    },
    ORDERBASIC_DETAILS_INFO(state, resp) {
      state.orderBasicInfoObj = resp.obj || {};
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //初始化新增预约装车
    async addInitPage({commit}, obj){
      let resp = await addInitPage(obj);
      commit('ADD_INIT_UPDATE', resp);
    },
    //初始化运输商
    async initCarrierData({ commit }, obj) {
      let resp = await getCarrierCode(obj);
      commit('INIT_CARRIER', resp);
    },
    //车辆列表
    async initTruckData({ commit }, obj) {
      let resp = await findTrucksByCarrierNo(obj);
      commit('INIT_TRUCK', resp);
    },
    //司机列表
    async initDriverData({ commit }, obj) {
      let resp = await findDriversByCarrierNo(obj);
      commit('INIT_DRIVER', resp);
    },
    //提交
    async submit({ commit }, obj) {
      let resp = await submit(obj);
      commit('SUBMIT_DATA', resp);
    },
    //新增车辆
    async saveTruckData({commit}, obj){
      let resp = await saveTruckData(obj);
      commit('SAVE_TRUCK_DATA', resp);
    },
    //新增司机事件
    async saveDriverData({commit}, obj){
      let resp = await saveDriverData(obj);
      commit('SAVE_DRIVER_DATA', resp);
    },
     //文件上传路径
     async uploadUrl({ commit }, obj) {
      let resp = await uploadUrl(obj);
      commit('UPLOAD_URL_DATA', resp);
    },
    //基本信息
    async orderBasicDetailsInfo({ commit }, obj) {
      let resp = await orderBasicDetailsInfo(obj);
      commit('ORDERBASIC_DETAILS_INFO', resp);
    },
  }
}
export default appointment



// WEBPACK FOOTER //
// ./src/page/transport/appointment/store/appointment.store.js